// @ts-nocheck
import { useState, Suspense } from 'react'
import _ from 'lodash'

import Field from '../../../fields'
import { colors } from '@lmc/common/constants'
import { getStockConfirmProps } from '../components/getEmarConfirmProps'
import { Icon, Text } from '@lmc/ui-kit'

interface EmarStockUnitsFieldProps {
  fields: Record<string, any>
  formId: string
  setFormField: (key: string, value: any) => void
  testId?: string
}

const STOCK_UNIT_OPTIONS = [
  { value: 'bottle', label: 'bottle' },
  { value: 'box', label: 'box' },
  { value: 'inhaler', label: 'inhaler' },
  { value: 'tube', label: 'tube' },
  { value: 'tub', label: 'tub' },
  { value: 'custom', label: 'Custom' }
]

/**
 * Returns stock units field
 * @param {EmarStockUnitsFieldProps} props - The component's props.
 * @returns {JSX.Element} EmarStockUnitsField.
 */
export default function EmarStockUnitsField(
  props: EmarStockUnitsFieldProps
): JSX.Element {
  const { fields, formId, setFormField, testId } = props

  const [editable, setEditable] = useState(
    !(
      fields.stockQuantityType &&
      fields.quantityType === fields.stockQuantityType
    )
  )
  const [fieldType, setFieldType] = useState('antdSelect')

  const Label = () => (
    <div
      style={styles.labelContainer}
      data-testid={testId ? `${testId}-stock-units-label` : 'stock-units-label'}
    >
      <Text style={styles.label} as="h5">
        Unit for counting
      </Text>
      <div style={styles.sublabel}>
        Tell us what is being counted. If the medication has no units you’ll
        need to specify what you’re counting, for example creams.
      </div>
    </div>
  )

  const options = _({ value: fields.quantityType, label: fields.quantityType })
    .concat(STOCK_UNIT_OPTIONS)
    .uniqBy('value')
    .filter('value')
    .value()

  const className = `lmc-antd-select-field ${
    !editable && 'lmc-antd-select-field-confirm'
  }`

  return (
    <div
      style={styles.container}
      data-testid={testId ? `${testId}-stock-units-field` : 'stock-units-field'}
    >
      <Label />
      <div style={styles.fieldContainer}>
        <div style={styles.field}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              askConfirm={!editable}
              className={className}
              confirmClassName="lmc-field-confirm"
              confirmProps={getStockConfirmProps()}
              formId={formId}
              keys="stockQuantityType"
              layout="no-label"
              options={options}
              onChange={(value) => {
                setEditable(fields.quantityType !== value)

                if (value === 'custom') {
                  setFieldType('text')
                  setFormField({ key: 'stockQuantityType', value: null })
                }
              }}
              onConfirm={() => setEditable(true)}
              placeholder={fieldType === 'text' ? 'Enter custom unit' : null}
              type={fieldType}
              values={fields}
            />
          </Suspense>
        </div>
        {fieldType === 'text' && (
          <div
            onClick={() => {
              setFieldType('antdSelect')
              setFormField({ key: 'stockQuantityType', value: null })
            }}
            style={styles.cancelBtn}
          >
            <Icon name="CloseOutlined" />
          </div>
        )}
      </div>
    </div>
  )
}

const styles = {
  cancelBtn: {
    cursor: 'pointer',
    marginLeft: 8
  },
  container: {
    background: 'white',
    borderRadius: 15,
    padding: 16,
    marginTop: 16
  },
  field: {
    maxWidth: 180
  },
  fieldContainer: {
    alignItems: 'center',
    display: 'flex'
  },
  label: {},
  labelContainer: {
    marginBottom: 16
  },
  sublabel: {
    color: colors.darkgrey,
    fontSize: 12,
    lineHeight: '18px'
  }
}
